import * as z from "zod";

const LocationMappingSchema_ = z.object({
  id: z.bigint(),
  connectionId: z.bigint(),
  locationId: z.bigint(),
  externalLocationId: z.string(),
  locationName: z.string(),
  createdAt: z.date(),
});

const LocationSchema_ = z.object({ id: z.bigint(), name: z.string() });

export const getLocationMappings = {
  name: "getLocationMappings" as const,
  input: z.null(),
  output: z.object({
    locations: z.array(LocationSchema_),
    mappings: z.array(LocationMappingSchema_),
  }),
};
